import {
	ApiRequestContextData,
	GetApplicationHeadersOptions,
} from "@utils/api-config/types";
import { getCurrentLanguage } from "@utils/common/culture";

export function getApplicationRequestHeaders(
	context: ApiRequestContextData | null,
	options: GetApplicationHeadersOptions = { shouldSetToken: true }
) {
	const { shouldSetToken = true } = options;
	const headers: Record<string, string> = {
		"Accept-Language": getCurrentLanguage(),
		"Caller-Environment": WEBPACK_ENVIRONMENT_KEY,
	};

	if (!context) {
		return headers;
	}

	if (shouldSetToken && context.authToken) {
		headers["Authorization"] = `Bearer ${context.authToken}`;
	}
	if (context.shopId) {
		headers["Shop-Id"] = context.shopId;
	}

	return headers;
}
